import styles from "./Details.module.scss";
import cars from "./assets/backgrounds/cars.webp";
import { GlitchText } from "./components/Glitch";
import Select from "./components/Select";

const Events = () => {
	const scrollTo = (element) => {
		element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		// window.scrollTop = element.offsetTop;
		// window.scroll({top: element.offsetTop, behavior: "smooth"})
		window.scrollBy(0, -200);
	}
	return (
		<div className={styles.Events}>
			<header className={styles.header}>
				<img src={cars} alt="" />
			</header>
			<aside>
				<GlitchText>EVENT DETAILS</GlitchText>
			</aside>
			<section className="body">
				<div className="content fixYSkew">
					<Select scrollTo={scrollTo} />
				</div>
			</section>
		</div>
	);
};

export default Events;
